import HttpService from './HttpService';

class NotificationService {
    constructor() {
        this.api = HttpService;
    }

    async getNotifications(limit = 50, unreadOnly = false) {
        const response = await this.api.get(`/notifications?limit=${limit}&unread_only=${unreadOnly}`);
        return response.data;
    }

    async getUnreadCount() {
        const response = await this.api.get('/notifications/unread-count');
        return response.data;
    }

    async markAsRead(notificationId) {
        const response = await this.api.post(`/notifications/${notificationId}/read`);
        return response.data;
    }

    async markAllAsRead() {
        const response = await this.api.post('/notifications/mark-all-read');
        return response.data;
    }

    async dismiss(notificationId) {
        const response = await this.api.post(`/notifications/${notificationId}/dismiss`);
        return response.data;
    }
}

export default new NotificationService();
